// (C) Copyright 2020 MediaWink, LLC

// Input selectors
export const selectHtml = (state) => state.html;
